<template>
    <non-essential-cookies-prompt
        v-if="!embedLoaded"
        :saving="consentRecording"
        :failed="consentFailed"
        @consent="consentToWherebyEmbed"
    />
    <div v-else class="relative transition-all duration-700" :class="embedContainerClasses">
        <whereby-embed
            :room="session_url"
            :displayname="display_name"
            people="off"
            lang="en"
            screenshare="on"
            minimal
            floatSelf="on"
            @ready="readyEventFired"
            @join="joinEventFired"
            class="absolute inset-0"
        ></whereby-embed>
    </div>
</template>
<script>
import loadWherebyEmbed, {
    consentToWherebyEmbed,
    wherebyEmbedConsented,
    wherebyEmbedConsentFailed,
    wherebyEmbedConsentRecording,
} from '../../helpers/loadWherebyEmbed';
import NonEssentialCookiesPrompt from '../cookie-banner/NonEssentialCookiesPrompt.vue';

export default {
    components: {
        NonEssentialCookiesPrompt,
    },
    props: {
        session_url: String,
        display_name: String
    },
    data() {
        return {
            embedState: 'init',
            isNotChrome: true
        }
    },
    created() {
        // Consent from the banner or from this embed's prompt: load the embed script.
        this.$watch(() => wherebyEmbedConsented.value, (consented) => {
            if (consented) {
                loadWherebyEmbed();
            }
        }, { immediate: true });
    },
    mounted() {
        this.browserDetection();

        addEventListener('beforeunload', this.preventAccidentalNavigation, {capture: true});
    },
    methods: {
        consentToWherebyEmbed,
        readyEventFired(event) {
        },
        joinEventFired(event) {
            this.embedState = 'approved'
        },
        preventAccidentalNavigation(event) {
            event.preventDefault();
            return event.returnValue = _mft('coaching:session.embedded.leaving.areYouSure');
        },

        browserDetection() {
            if(navigator.userAgent.match(/chrome|chromium|crios/i)) {
                this.isNotChrome = false;
            }
        }
    },
    computed: {
        embedLoaded() {
            return wherebyEmbedConsented.value
        },
        consentRecording() {
            return wherebyEmbedConsentRecording.value
        },
        consentFailed() {
            return wherebyEmbedConsentFailed.value
        },
        embedContainerClasses() {
            if( this.embedState === 'approved' ){
                return 'pb-[56.25%]'
            } else {
                return 'pb-[200%] md:pb-[175%] lg:pb-[125%] xl:pb-[100%]'
            }
        }
    }
}
</script>
